import { nextPracticeFilterValue } from '../domain/raidPracticeFilterState.js';

const ELEMENTS = ['전체', '작열', '수냉', '전격', '풍압', '철갑'];
const BURSTS = ['전체', '1', '2', '3', 'A'];
const BURST_LABELS = { 전체: '버스트 전체', 1: 'I', 2: 'II', 3: 'III', A: 'A' };

export function RaidPracticeNikkeFilters({ element, burst, onElementChange, onBurstChange }) {
  return (
    <div className="raid-practice-nikke-filters">
      <div>
        {ELEMENTS.map((item) => (
          <button
            type="button"
            key={item}
            className={element === item ? 'active' : ''}
            onClick={() => onElementChange(nextPracticeFilterValue(element, item))}
          >
            {item}
          </button>
        ))}
      </div>
      <div>
        {BURSTS.map((item) => (
          <button
            type="button"
            key={item}
            className={burst === item ? 'active' : ''}
            onClick={() => onBurstChange(nextPracticeFilterValue(burst, item))}
          >
            {BURST_LABELS[item]}
          </button>
        ))}
      </div>
    </div>
  );
}
